<template>
  <div
    style="padding:10px 5px;height:calc(100% - 20px)"
    class="uk-position-relative">
    <v-search
      v-bind="searchAttrs"
      @searchFn="search"
      @deleteFn="mulDel"
      @batchStatusFn="batchStatus"
      @batchHandleFn="batchHandle"
      @resetFn="resetFn"
    />
    <!-- <div class="componentPage"> -->
      <SuperTable
        ref="stable"
        style="height:calc(100% - 150px)"
        :req="exPage"
        :params="[searchAttrs.SearchForm]"
        :columns="columns"
        :selection="true"
      >
        <template #operation="{ row }">
          <i
            class="iconfont icon-gongdanqueren cursor-pointer mr-5"
            :title="$t('integration.handle')"
            @click="handle(row)"
          ></i>
          <i
            class="iconfont icon-git-branch-line cursor-pointer mr-5"
            :title="$t('integration.sign')"
            @click="remark(row)"
          ></i>
          <i
            class="el-icon-document cursor-pointer mr-5"
            :title="$t('integration.details')"
            @click="detail(row)"
          ></i>
          <i
            class="el-icon-delete cursor-pointer"
            :title="$t('public.btn_delete')"
            @click="del(row)"
          ></i>
        </template>
      </SuperTable>

      <div class="question">
        <span class="filter-label">{{ $t('public.filter') }}</span>
        <el-select v-model="type" multiple :placeholder="$t('integration.display_info')"
           :style="{ width: selectWidth }"
           @change="searchListInvalidMsg">
          <el-option
            v-for="item in invalidMsg"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value">
            <el-checkbox disabled class="my-checkbox">
              <i v-if="type.findIndex(_ => _ === item.value) !== -1" class="el-icon-check my-checkbox-check"></i>
              {{ $t(item.label) }}
            </el-checkbox>
            <div class="info-icon" :style="{'background-color': item.color}"></div>
          </el-option>
        </el-select>
        <i class="iconfont icon-shaixuan cursor-pointer ml-5" @click="handleShowRule"></i>
      </div>

      <HandleDialog :isShow="isShowHandleDialog"
        :exDetail="exDetail"
        :exId="exId"
        @close="isShowHandleDialog = false"
      />

      <RemarkDialog v-if="isShowRemarkDialog" :isShow="isShowRemarkDialog"
        :exId="exId"
        :excludeStatus="excludeStatus"
        :carrierName="remarkRow.carrierName"
        :carrierDeviceName="remarkRow.carrierDeviceName"
        :batch="false"
        @close="isShowRemarkDialog = false"
      />
      <RemarkDialog v-if="isShowBatchRemarkDialog" :isShow="isShowBatchRemarkDialog"
        :batch="true"
        :exIds="batchExIds"
        @close="isShowBatchRemarkDialog = false"
      />

      <BatchHandleDialog v-if="isShowBatchHandleDialog" :isShow="isShowBatchHandleDialog"
        :exIds="batchExIds"
        :detail="batchDetail"
        @close="isShowBatchHandleDialog = false"
      />

    <ExDetailDia :fromInvalid="true"></ExDetailDia>

    <RuleDialog
      v-if="isShowRuleDialog"
      :isShow="isShowRuleDialog"
      @close="isShowRuleDialog = false"
    />

   </div>
</template>
<script>
import SuperTable from '@/components/SuperTable/SuperTable.vue'
import { exPage, delEx } from '@/api/modules/abnormal.js'

import { getColumns } from "./columns.js"
import HandleDialog from './handle/HandleDialog.vue'
import RemarkDialog from './RemarkDialog.vue'
import BatchHandleDialog from './BatchHandleDialog.vue'
import { invalidMsg,alarmReason } from '@/utils/convert.js'
import ExDetailDia from '@/pages/abnormal/component/ExDetailDia/ExDetailDia.vue'
import bus from '@/utils/bus'
import RuleDialog from './RuleDialog.vue'
import getRange from '@/utils/getRange.js';
import { getCarrierType, shareTree } from '@/api/modules/public'
import { getLanguage } from '@/lang'

// 异常类型 code → i18n key 映射（用于搜索栏下拉框选项响应式语言切换）
const alarmReasonKeys = {
  0: 'integration.abnormal_connection',
  1: 'integration.abnormal_data',
  2: 'integration.abnormal_power_failure'
}

export default {
  mixins: [getRange],

  components: { SuperTable, HandleDialog, RemarkDialog, BatchHandleDialog, ExDetailDia, RuleDialog},

  data() {
    return {
      invalidMsg,
      exPage,
      // 条件搜索属性整合
      // 注意：text/label 字段存 i18n key 字符串（而非预翻译值），由 Search.vue 在模板内调用 $t(item.text) 实时响应语言切换
      searchAttrs: {
        formContent: [ // 搜索form
          {
              id: 1,
              text: 'integration.ir_carrier',
              type: 'input',
              paramsName: 'carrierName',
              isChooze: false
          },
           {
              id: 2,
              text: 'integration.ir_installation_point',
              type: 'input',
              paramsName: 'carrierDeviceName',
              isChooze: false
          },
          {
              id: 3,
              text: 'public.table_scope',
              type: 'select',
              paramsName: 'sceneId',
              selectParam: [],
              isChooze: true
          },
          {
              id: 4,
              text: 'route.scene',
              type: 'selecttree',
              paramsName: 'structureId',
              selectParam: [],
              isChooze: true,
              label: '',
          },
          {
              id: 5,
              text: 'integration.ir_type',
              type: 'select',
              paramsName: 'exCatalog',
              selectParam: [],
              isChooze: true
          },
          {
              id: 6,
              text: 'integration.ir_abnormal_time',
              type: 'datetimerange',
              paramsName: 'time',
              isChooze: false
          },
          {
              id: 7,
              text: 'integration.ir_carrier_type',
              type: 'select',
              paramsName: 'carrierType',
              selectParam: [],
              isChooze: true
          },
          {
              id: 8,
              text: 'integration.ir_close',
              type: 'select',
              paramsName: 'status',
              selectParam: [
                {
                  value: 1,
                  label: 'public.yes'
                },
                {
                  value: 0,
                  label: 'public.no'
                }
              ],
              isChooze: true
          },


        ],
         SearchForm: { // 搜索提交上去的参数
          status: null, //是否关闭
          sceneId: null, //客户ID
          from: null,
          to: null,
          time: [],
          carrierId: null,
          carrierName: null, //监测点名称
          carrierDeviceName: null, //安装点名称
          carrierType: null, //监测点类型
          exCatalog: null, //异常类型
          iDisplayLength: 15,
          iDisplayStart: 0,
          structureId: null, // 架构ID
          alarm: 1,
          excludeStatus: null
        },
        inline: true,
        optareBtn: [ // 操作按钮
          {
            id: 1,
            icon: '',
            text: 'integration.handle',
            method: 'batchHandleFn'
          },
          {
            id: 2,
            icon: '',
            text: 'integration.ir_status',
            method: 'batchStatusFn'
          },
          {
            id: 3,
            icon: '',
            text: 'integration.delete',
            method: 'deleteFn'
          },
        ]
      },
      isShowHandleDialog: false,
      exDetail: {},
      exId: null,

      isShowRemarkDialog: false,
      remarkRow: {},

      isShowBatchRemarkDialog: false,
      batchExIds: [],

      isShowBatchHandleDialog: false,
      batchDetail: [],

      type: ['abnormal'],

      isShowRuleDialog: false,

      excludeStatus: null,

    }
  },
  watch: {
    '$store.state.exType': {
      handler (newval) {
        const item = this.searchAttrs.formContent.find(
          item => item.paramsName === 'exCatalog'
        )
        if (item) {
          const result = []
          Object.keys(newval).forEach(key => {
            // label 存 i18n key 字符串，由 Search.vue 的 $t(option.label) 实时翻译
            const code = newval[key].code
            result.push({
              label: alarmReasonKeys[code] || (alarmReason[code] && this.$t(alarmReason[code].title)) || '',
              value: code
            })
          })
          item.selectParam = result
        }
      }
    }
  },
  computed: {
    // 表格列定义为 computed，依赖 $i18n.locale 触发重新求值，实现表头实时切换语言
    columns () {
      // 触发依赖：$i18n.locale 变化时 getColumns() 重新执行
      const _locale = this.$i18n.locale
      return getColumns()
    },
    // 多选下拉框自适应宽度：根据选中项数量动态计算宽度
    selectWidth () {
      const n = this.type.length
      if (n === 0) return '200px'
      return (n * 80 + 40) + 'px'
    }
  },
  mounted () {
    this.$store.dispatch('exType')

    // 默认选中 False（normal），触发筛选事件
    this.searchListInvalidMsg()
    this.getRangeFn()
    this.getCarrierType()
    // 获取组织架构
    // this.getTree()
  },
  methods: {
    getList () {
      this.$refs.stable.getList()
    },
    search (params) {
      if (params.time && params.time.length > 0) {
        // 将时间定义为不可被枚举 从而阻止其提交至后台
        if (this.searchAttrs.SearchForm.propertyIsEnumerable('time')) {
          Object.defineProperty(this.searchAttrs.SearchForm, 'time', {
            value: this.searchAttrs.SearchForm.time,
            enumerable: false,
            configurable: true,
            writable: true
          })
        }

        this.searchAttrs.SearchForm.from = new Date(params.time[0]).getTime()
        this.searchAttrs.SearchForm.to = new Date(params.time[1]).getTime()

      }
      this.getList()
    },
    async mulDel(){
      const selection = this.$refs.stable.getSelection()
      if (!selection.length) {
        this.$message.warning($t('integration.please_select_at_least_one_data'))
        return
      }

      this.del(selection)
    },
    resetFn(){
      let alarm = this.searchAttrs.SearchForm.alarm
      this.searchAttrs.SearchForm = {
        status: null, //是否关闭
          sceneId: null, //客户ID
          from: null,
          to: null,
          time: [],
          carrierId: null,
          carrierName: null, //监测点名称
          carrierDeviceName: null, //安装点名称
          carrierType: null, //监测点类型
          exCatalog: null, //异常类型
          iDisplayLength: 15,
          iDisplayStart: 0,
          structureId: null, // 架构ID
          alarm: alarm,
          excludeStatus: null
       }
      // 重置筛选为默认选中 Confirmed（abnormal）
      this.type = ['abnormal']
      this.searchListInvalidMsg()
    },
    del (row) {
      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_exception_q')).then(() => {
        let ids = null
        if (row instanceof Array) {
          ids = row.map(item => item.id)
        } else {
          ids = [row.id]
        }
        delEx(ids).then(res => {
          switch (res.result) {
            case 200:
              this.$message.success($t('integration.successfully_deleted'))
              this.getList()
              break
            case 400:
              this.$message.error($t('integration.delete_failed'))
              break
          }
        })
      })
    },
    handle(row){
      this.isShowHandleDialog = true
      this.exDetail = [row]
      this.exId = row.id
    },
    remark(row){
      this.isShowRemarkDialog = true
      this.exId = row.id
      this.excludeStatus = row.excludeStatus
      this.remarkRow = row
    },
    batchStatus(){
      const selection = this.$refs.stable.getSelection()
      if (!selection.length) {
        this.$message.warning($t('integration.please_select_at_least_one_data'))
        return
      }
      this.batchExIds = selection.map(item => item.id)
      this.isShowBatchRemarkDialog = true
    },
    batchHandle(){
      const selection = this.$refs.stable.getSelection()
      if (!selection.length) {
        this.$message.warning($t('integration.please_select_at_least_one_data'))
        return
      }
      this.batchExIds = selection.map(item => item.id)
      this.batchDetail = selection
      this.isShowBatchHandleDialog = true
    },
    detail (row) {
      bus.$emit('exDetail', {
        id: row.id
      })
    },
    handleShowRule(){
      this.isShowRuleDialog = true
    },
    // 根据显示信息筛选list
    searchListInvalidMsg(){
      console.log(this.type)
      let typeArr = []
      this.type.forEach(item => {
        if(item === 'normal'){
          typeArr.push(0)
        }else if(item === 'abnormal'){
          typeArr.push(1)
        }else{
          typeArr.push(2)
        }
      })
      console.log(typeArr.join())
      this.searchAttrs.SearchForm.excludeStatus = typeArr.join()
      this.getList()

    },
    // 获取客户下拉数据
    getRangeFn() {
      this.getCustomerList({
          tab: 1
      }).then(({ result }) => {
          this.searchAttrs.formContent[2].selectParam = result.slice(1).map(item => {
              return {
                  value: item.id,
                  label: item.name
              };
          });
          this.searchAttrs.formContent[2].selectParam.unshift({
              value: '',
              label: 'public.please'
          });
      });
    },
    // 获取监测点类型下拉框
    getCarrierType () {
      getCarrierType().then(({ result }) => {
       const item = this.searchAttrs.formContent.find(
          item => item.paramsName === 'carrierType'
        )
        if (item) {
          item.selectParam = result.map(item => {
              return {
                  value: item.id,
                  label: getLanguage() === 'zh_CN'? item.name: item.code
              };
          });
        }
      })
    },
    // 获取组织架构
    async getTree(obj = '') {
    let query = {};
    // 根据不同角色账户传递不同参数 获取不同树
    if (this.$store.state.type === 3 || this.$store.state.type === 2) {
        query = { idEdit: 0, all: true };
    } else {
        query = { idEdit: 0 };
    }
    let { result } = await shareTree(query);
    if (result.item[0].sceneCode === 'all_node') {
        result.item[0].label = this.$t('public.All');
    }
    let treeData = []

    if (this.$store.state.type === 3 || this.$store.state.type === 2) {
        treeData = result.item.slice(1);
    } else {
        treeData = result.item;
    }
    const item = this.searchAttrs.formContent.find(
        item => item.paramsName === 'structureId'
      )
      if (item) {
        item.selectParam = treeData.map(item => {
            return {
                value: item.id,
                label: item.label
            };
        });
      }

    },
  }
}
</script>
<style lang="scss" scoped>
.question {
  position: absolute;
  right: 15px;
  top: 22px;
  font-size: 18px;
  z-index: 999;
  cursor: pointer;
  color: gray;
  display: flex;
  align-items: center;
  ::v-deep.el-select__tags {
    flex-wrap: nowrap;
    overflow: hidden;
  }
}
.filter-label {
  font-size: 14px;
  margin-right: 8px;
  white-space: nowrap;
}
.info-icon {
  width: 25px;
  height: 15px;
  float: right;
  margin-top: 10px;
  margin-left: 5px;
}
.my-checkbox {
  position: relative;
  ::v-deep .el-checkbox__label {
    color: #333333 !important;
    cursor: pointer !important;
  }
  ::v-deep .el-checkbox__inner {
    color: #333333 !important;
    cursor: pointer !important;
    background-color: #FFFFFF !important;
  }
  .my-checkbox-check {
    position: absolute;
    left: 0px;
    top: 10px;
    z-index: 999;
    font-weight: bold;
  }
}
::v-deep .el-select-dropdown__item {
  &::after {
    content: '' !important;
  }
}

</style>
